import { Component, h, Host, Prop } from '@stencil/core';
import get from 'lodash/get';
import { QueryParamsHelpers } from '../../../../../shared/helpers/query-params.helpers';

@Component({
  tag: 'header-promo',
  styleUrl: 'header-promo.scss',
})
export class HeaderPromo {
  @Prop() categoryId: number;
  @Prop() parentCategoryId?: number;
  @Prop() isCheckout: boolean;
  @Prop() region: string;

  translate = (key) => {
    return get(window['headerPromo'], key, key);
  }

  isHomepage(): boolean {
    return /\/.{2}\/?$/.test(window.location.pathname) || window.location.pathname === '/';
  }

  isCompatibleCategory(): boolean {
    // is mens health
    return this.parentCategoryId === 1;
  }

  isActiveCampaign(): boolean {
    return QueryParamsHelpers.queryParams.utm_source?.toLowerCase() === 'activecampaign';
  }

  isCompatibleBridgePage(): boolean {
    return ['30', '31', '32', '1313088731'].includes(QueryParamsHelpers.queryParams.category_id)
  }

  isEnabled(): boolean {
    return this.translate('isEnabled') === true
        && !this.isActiveCampaign()
        && (this.isHomepage() || this.isCompatibleCategory() || this.isCompatibleBridgePage());
  }

  /*
  Commented for future promos

  render() {
    return this.isEnabled() ? <Host class={this.isCheckout ? 'with-bg' : ''}>
      <div class='header__promo'>
        <span class="header__promo-text">
          <span class="title-left">{this.translate('titleLeft')}</span>
          <span class="discount" innerHTML={this.translate('titleCenter')}></span>
          <span class="title-right">{this.translate('titleRight')}</span>
        </span>
      </div>
    </Host> : '';
  }
  */


  // Hardcodeded methods just for 2024 autumn-winter promotions

  getContent() {
    const content = {
      mainPromoText: '',
      secondaryPromoText: '',
      discountSize: '',
      discountDescription: '',
    };
    switch(this.region) {
      case 'ch':
        content.mainPromoText = '2025 – Bessere Gesundheit, besserer Sex';
        content.secondaryPromoText = 'Sparen Sie jetzt';
        content.discountSize = '10%';
        content.discountDescription = 'auf Potenzbehandlungen';
        break;
      case 'de':
        content.mainPromoText = '2025 – Bessere Gesundheit, besserer Sex';
        content.secondaryPromoText = 'Sparen Sie jetzt';
        content.discountSize = '15%';
        content.discountDescription = 'auf Potenzbehandlungen';
        break;
      case 'pt':
        content.mainPromoText = '2025 - Mais Saúde, Melhor Sexo';
        content.secondaryPromoText = 'Poupe já';
        content.discountSize = '10%';
        content.discountDescription = 'em tratamentos para a disfunção erétil';
        break;
      case 'dk':
        content.mainPromoText = '2025 - Bedre helbred, bedre sex';
        content.secondaryPromoText = 'Spar';
        content.discountSize = '10%';
        content.discountDescription = 'på ED-behandlinger nu';
        break;
      case 'se':
        content.mainPromoText = '2025 - Bättre hälsa, bättre sex';
        content.secondaryPromoText = 'Spara';
        content.discountSize = '10%';
        content.discountDescription = 'på ED-behandlingar nu';
        break;
      case 'nl':
        content.mainPromoText = '2025 - Betere gezondheid, betere seks';
        content.secondaryPromoText = 'Bespaar nu';
        content.discountSize = '10%';
        content.discountDescription = 'op ED-behandelingen';
        break;
    }
    return content;
  }

  render() {
    const content = this.getContent();
    return this.isEnabled() ? <Host>
      <div class={`header__promo ${this.region}`}>
        <span class="header__promo-text">
          {content.mainPromoText}
        </span>
        <span class="header__promo-text">
          <span class="title-left">{content.secondaryPromoText}</span>
          &nbsp;<span class="discount-size">{content.discountSize}</span>&nbsp;
          <span class="discount-description">{content.discountDescription}</span>
        </span>
      </div>
    </Host> : '';
  }
}
